import React, { useEffect, useState } from "react";
import { basePath, hexConverter } from "../Components/Helpers";
import useMediaQuery from "../Hooks/useMediaQuery";

const MemoryCard = ({card, handleChoice, flipped, disabled, matched} ) => {

    const [randomColor, setRandomColor] = useState();

    const handleCardClick = () => {
        if(!disabled)
        handleChoice(card)
    };

    const isBigScreen = useMediaQuery('(min-width: 64rem)');
    const borderWidth = isBigScreen ? 6 : 3;

    useEffect(() => {
        if(matched){
            const rgbColor = hexConverter(card.colorIndex);
            setRandomColor(rgbColor);
        }
    }, [matched]);

    let noMatch = card.hasOwnProperty("noMatch");

    return(
        <div className={`card-grid__card ${noMatch ? "noMatchCard" : ""}`}>
            <div className={`card-grid__card__inner ${flipped ? 'flipped' : ''}`}>
                <img style={{border: `${matched ? `${borderWidth}px solid` + randomColor : `${borderWidth}px solid #6ec05d`}`}} className="card-grid__card__front" loading="lazy" src={`https://${card.image}?format=webp&qualtiy=70&width=150&height=230`} alt="" />
                <img className="card-grid__card__back"
                    src={"/memorycard-back.png"} 
                    alt=""
                    onClick={() => handleCardClick()} 
                     />
            </div>
        </div>
    );
};

export default MemoryCard;